import type { ReactNode } from "react";
import { Link, useRouterState } from "@tanstack/react-router";
import { Button } from "@patient-watch/ui";
import { cn } from "@patient-watch/ui/utils";
import { useAdminAccess } from "../stores/adminAccessStore";

interface AdminLayoutProps {
    children: ReactNode;
}

const adminTabs = [
    { label: "Participant overview", to: "/admin" as const },
    { label: "Export participant data by date range", to: "/export" as const },
    { label: "View study tracker", to: "/study-tracker" as const },
];

export function AdminLayout({ children }: AdminLayoutProps) {
    const { lock } = useAdminAccess();
    const pathname = useRouterState({ select: (state) => state.location.pathname });

    return (
        <div className="p-4">
            <div className="space-y-6 mx-auto w-full min-w-0 max-w-6xl">
                <div className="flex sm:flex-row flex-col sm:justify-between sm:items-start gap-4">
                    <div className="space-y-4 min-w-0">
                        <div>
                            <h1 className="font-bold text-slate-900 text-3xl">Admin Dashboard</h1>
                            <p className="text-slate-600">SeaGM Glucose Watch Study - Participant Overview</p>
                        </div>

                        <nav className="flex flex-wrap gap-1 border-slate-200 border-b">
                            {adminTabs.map((tab) => {
                                const isActive = pathname === tab.to;

                                return (
                                    <Link
                                        key={tab.to}
                                        to={tab.to}
                                        className={cn(
                                            "-mb-px px-3 py-2 border-b-2 font-medium text-sm whitespace-nowrap transition-colors",
                                            isActive
                                                ? "border-indigo-600 text-indigo-600"
                                                : "border-transparent text-slate-600 hover:border-slate-300 hover:text-slate-900"
                                        )}
                                    >
                                        {tab.label}
                                    </Link>
                                );
                            })}
                        </nav>
                    </div>

                    <Button variant="outline" size="sm" onClick={lock} className="shrink-0">
                        Lock admin area
                    </Button>
                </div>

                {children}
            </div>
        </div>
    );
}
